import {isMobile} from '../../../../../commons/selectors/environment'
import {getFormButtonStyle} from '../../selectors/settings'
import {DetailsPageAppProps} from '../app/interfaces'
import {connect} from '../runtime-context/context'
import {FormButton as Presentation} from './form-button'
import {FormButtonOwnProps, FormButtonRuntimeProps} from './interfaces'

const mapRuntimeToProps = ({state}: DetailsPageAppProps): FormButtonRuntimeProps => ({
  mobile: isMobile(state),
  buttonStyle: getFormButtonStyle(state.component.settings),
})

export const FormButton = connect<FormButtonOwnProps, FormButtonRuntimeProps>(mapRuntimeToProps)(Presentation)
